// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"ActivityIndicator_spinnerContainer__NrUzk","spinner":"ActivityIndicator_spinner__YFCLL","spin":"ActivityIndicator_spin__KsFFb"};